import { ApiError, errorMessage } from "@/lib/api/errors";

/** What went wrong with checkout or the billing portal, in words a person can act on. */
export function billingMessage(error: unknown): string {
  if (error instanceof ApiError && error.code === "billing_unavailable") {
    return "Subscribing on the web isn’t open yet. Please try again soon.";
  }
  if (error instanceof ApiError && error.code === "already_subscribed") {
    return "You’re already on Antar.";
  }
  if (error instanceof ApiError && error.code === "no_billing_customer") {
    return "This subscription was bought on a phone. Manage it in that app store.";
  }
  return errorMessage(error);
}
